import {RegionActions, RegionActionTypes} from '../actions/region.actions';
import {Region} from '../region.model';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';


export interface RegionState extends EntityState<Region> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Region> = createEntityAdapter<Region>({
  selectId: region => region.Id
});

export const initialState: RegionState = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(state = initialState, action: RegionActions): RegionState {
  switch (action.type) {
    case RegionActionTypes.GetRegions:
      adapter.removeAll(state);
      return {...state, Loaded: false, Loading: true};

    case RegionActionTypes.LoadRegions:
      return adapter.setAll(action.payload, {...state, Loaded: true, Loading: false});

    case RegionActionTypes.AddRegions:
      return {...state, Loaded: false, Loading: true};

    case RegionActionTypes.UpdateRegions:
      return adapter.updateOne(action.payload, state);

    case RegionActionTypes.DeleteRegions:
      return adapter.removeOne(action.payload.id, state);

    case RegionActionTypes.RemoveRegions:
      return adapter.removeAll(state);
    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
